export enum SignalREvent {
    BalanceModified = "BalanceModified",
}

export enum SignalRMessage {
    _ = "" // not used thus far, left empty value for typechecks
}